import { fetchWithAuth } from "../lib/api";

export type LeadActionKind = "claim" | "convert";
export interface LeadActionResult {
  ok: boolean;
  code: "claimed" | "converted" | "ownership_conflict";
  lead_id: string;
  owner_user_id: string;
  owner_full_name?: string | null;
  client_id: string | null;
  task_id: string | null;
  replayed: boolean;
}

export class LeadConflictError extends Error {
  constructor(public readonly result: LeadActionResult) {
    super("This lead was already claimed. The current owner is shown.");
  }
}

export async function runLeadAction(
  leadId: string,
  action: LeadActionKind,
  requestId: string = crypto.randomUUID(),
  requestedOwnerId?: string
): Promise<LeadActionResult> {
  try {
    return await fetchWithAuth<LeadActionResult>(`/leads/${encodeURIComponent(leadId)}/claim-convert`, {
      method: "POST",
      body: JSON.stringify({ request_id: requestId, action, requested_owner_id: requestedOwnerId }),
    });
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    const jsonStart = message.indexOf("{");
    if (jsonStart >= 0) {
      try {
        const body = JSON.parse(message.slice(jsonStart));
        const detail = body?.detail;
        if (detail?.code === "ownership_conflict") throw new LeadConflictError(detail);
      } catch (parsed) {
        if (parsed instanceof LeadConflictError) throw parsed;
      }
    }
    throw error;
  }
}
